import React, { useContext } from 'react';
import styles from './index.module.css';
import { Card, Typography } from 'antd';
import { DashboardContext } from '../..';
import {
  convertAmoutToINRWithNotation,
  getPortfolioObject,
} from '../../../../Utils/utils';
type Props = {};

const Home = (props: Props) => {
  const { portfolioList }: any = useContext(DashboardContext);
  const portfolioObject: any = getPortfolioObject(portfolioList);

  return (
    <div className={styles.portfolio_home}>
      <Card className={styles.portfolio_card}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Typography.Text>Total Networth</Typography.Text>
          <Typography.Text>
            {' '}
            ₹ {convertAmoutToINRWithNotation(portfolioObject!.totalNetworth)}
          </Typography.Text>
        </div>
      </Card>
      <Card
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
        className={styles.portfolio_card}
      >
        {' '}
        <Typography.Text>Total Networth</Typography.Text>
        <Typography.Text>
          {' '}
          ₹ {convertAmoutToINRWithNotation(portfolioObject!.totalNetworth)}
        </Typography.Text>
      </Card>

      <Card
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
        className={styles.portfolio_card}
      >
        {' '}
        <Typography.Text>Total Networth</Typography.Text>
        <Typography.Text>
          {' '}
          ₹ {convertAmoutToINRWithNotation(portfolioObject!.totalNetworth)}
        </Typography.Text>
      </Card>

      <Card
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
        className={styles.portfolio_card}
      >
        {' '}
        <Typography.Text>Total Networth</Typography.Text>
        <Typography.Text>
          {' '}
          ₹ {convertAmoutToINRWithNotation(portfolioObject!.totalNetworth)}
        </Typography.Text>
      </Card>
      <Card
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
        className={styles.portfolio_card}
      >
        {' '}
        <Typography.Text>Total Networth</Typography.Text>
        <Typography.Text>
          {' '}
          ₹ {convertAmoutToINRWithNotation(portfolioObject!.totalNetworth)}
        </Typography.Text>
      </Card>
    </div>
  );
};

export default Home;
